import axiosClient from "../../api/axiosClient";

export const createSchoolFromServer = async (formData) => {
    const response = await axiosClient.post("/schools", formData);

    return response.data;
};